import React, { useState } from "react";
import "./ScrollToTopButton.css";

const ScrollTop = () => {
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  window.addEventListener("scroll", checkScrollTop);

  return (
    <div
      className={`scrollToTopButton ${showScroll ? "show" : ""}`}
      onClick={scrollTop}
    >
      <img src="/assets/images/ScrolltoTopButton.svg" alt=""/>
    </div>
  );
};

export default ScrollTop;
